export default "__VITE_ASSET__21ead8c7__"